module.exports = __webpack_public_path__ + "static/media/text-en.d855b04f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/lucky-chiken/text-en.png
// module id = 2469
// module chunks = 7